import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SortConfig, SortDirection } from "types/common";

export interface ClinicState {
  atheletesList: string[];
  sortConfig: SortConfig;
  loadingAtheletes: boolean;
  offsetAthletesList: number;
  limitAtheletesList: number;
  totalAthletesList: number;
}

const initialState: ClinicState = {
  atheletesList: [],
  loadingAtheletes: false,
  offsetAthletesList: 0,
  limitAtheletesList: 5,
  totalAthletesList: 0,
  sortConfig: {
    sortBy: "athletes.name",
    sortDirection: SortDirection.desc,
  },
};

export const clinicSlice = createSlice({
  name: "Athletes",
  initialState,
  reducers: {
    resetPagination: (state) => {
      state.offsetAthletesList = initialState.offsetAthletesList;
      state.limitAtheletesList = initialState.limitAtheletesList;
      state.loadingAtheletes = initialState.loadingAtheletes;
      state.totalAthletesList = initialState.totalAthletesList;
    },
    setAthletesList: (state, { payload }: PayloadAction<string[]>) => {
      state.atheletesList = payload;
    },
    setLoadingAtletes: (state, { payload }: PayloadAction<boolean>) => {
      state.loadingAtheletes = payload;
    },
    setOffsetAthletesList: (state, { payload }: PayloadAction<number>) => {
      state.offsetAthletesList = payload;
    },
    setLimitAthletesList: (state, { payload }: PayloadAction<number>) => {
      state.limitAtheletesList = payload;
    },
    setTotalAthletesList: (state, { payload }: PayloadAction<number>) => {
      state.totalAthletesList = payload;
    },
    setSortConfig: (state, { payload }: PayloadAction<SortConfig>) => {
      state.sortConfig = payload;
    },
  },
});

export const { setLoadingAtletes, setOffsetAthletesList, setLimitAthletesList, setTotalAthletesList, setAthletesList } =
  clinicSlice.actions;
export const { reducer } = clinicSlice;
